var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageShipment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2619 6.23304L12.6369 0.966633C12.3797 0.824536 12.0907 0.75 11.7969 0.75C11.5031 0.75 11.214 0.824536 10.9569 0.966633L1.33187 6.23523C1.057 6.38562 0.827551 6.60706 0.667479 6.87641C0.507406 7.14576 0.422586 7.45315 0.421875 7.76648V18.2271C0.422586 18.5404 0.507406 18.8478 0.667479 19.1172C0.827551 19.3865 1.057 19.608 1.33187 19.7584L10.9569 25.0269C11.214 25.169 11.5031 25.2436 11.7969 25.2436C12.0907 25.2436 12.3797 25.169 12.6369 25.0269L22.2619 19.7584C22.5367 19.608 22.7662 19.3865 22.9263 19.1172C23.0863 18.8478 23.1712 18.5404 23.1719 18.2271V7.76757C23.1718 7.45369 23.0872 7.14562 22.9271 6.87563C22.767 6.60565 22.5372 6.3837 22.2619 6.23304ZM11.7969 2.49788L20.5852 7.31038L17.328 9.0921L8.53969 4.2796L11.7969 2.49788ZM11.7969 12.1229L3.00859 7.31038L6.7175 5.27929L15.5058 10.0918L11.7969 12.1229ZM21.4219 18.2315L12.6719 23.021V13.6355L16.1719 11.7204V15.6229C16.1719 15.8549 16.2641 16.0775 16.4282 16.2416C16.5923 16.4057 16.8148 16.4979 17.0469 16.4979C17.2789 16.4979 17.5015 16.4057 17.6656 16.2416C17.8297 16.0775 17.9219 15.8549 17.9219 15.6229V10.7623L21.4219 8.8471V18.2271V18.2315Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageShipment);
export default __webpack_public_path__ + "static/media/manage-shipment.60355781e9a7e21507ba9cd8ef3191f1.svg";
export { ForwardRef as ReactComponent };